export const getClientTimeZone = () =>
    Intl.DateTimeFormat().resolvedOptions().timeZone
